import initializeComponent from 'Shared/react-initialize';
import { LeaderboardDashboard } from './LeaderboardDashboard';

initializeComponent('Leaderboard', LeaderboardDashboard);
